"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMaxWidths = exports.getSizes = exports.MAX_SIZES = exports.cache = void 0;
var lodash_uniq_1 = __importDefault(require("lodash.uniq"));
var media_1 = require("../../../theme/media");
exports.cache = {
    __items: {},
    add: function (key) {
        this.__items[key] = true;
    },
    exists: function (key) {
        return this.__items[key] || false;
    },
};
var BREAKPOINTS_ARRAY = Object.entries(media_1.BREAKPOINTS);
exports.MAX_SIZES = BREAKPOINTS_ARRAY.reduce(function (acc, _a, i) {
    var _b;
    var _c = __read(_a, 1), breakpoint = _c[0];
    return (__assign(__assign({}, acc), (_b = {}, _b[breakpoint] = BREAKPOINTS_ARRAY[i + 1]
        ? BREAKPOINTS_ARRAY[i + 1][1]
        : BREAKPOINTS_ARRAY[i][1] * 1.5, _b)));
}, {});
var getSizes = function (config) {
    return Object.entries(config)
        .map(function (_a) {
        var _b = __read(_a, 2), breakpoint = _b[0], size = _b[1];
        return "".concat(media_1.breakpoints[breakpoint], " ").concat(size, "vw");
    })
        .reverse()
        .join(', ');
};
exports.getSizes = getSizes;
var getMaxWidths = function (config) {
    return (0, lodash_uniq_1.default)(Object.entries(config)
        .map(function (_a) {
        var _b = __read(_a, 2), breakpoint = _b[0], size = _b[1];
        var breakpointFullWidth = exports.MAX_SIZES[breakpoint];
        var breakpointMaxWidth = Math.ceil(breakpointFullWidth * (size / 100));
        return breakpointMaxWidth;
    })
        .flatMap(function (x) { return [x, x * 2]; }));
};
exports.getMaxWidths = getMaxWidths;
